<template>
  <!-- q-validation-component: register with QForm so this field validates first in document order -->
  <div :class="[containerClass, 'q-validation-component']">
    <div
      class="option-group-field"
      :class="{
        'option-group-field--error': hasError,
        'option-group-field--disabled': disable
      }"
    >
      <QOptionGroup
        ref="field"
        v-model="localValue"
        class="option-group-field__group"
        :options="options"
        :inline="inline"
        :disable="disable"
        :color="color"
        @input="handleInput"
      >
        <template v-slot:label="opt">
          <slot name="label" :opt="opt" :hasError="hasError">
            <div class="customer-selection-option">
              <span class="customer-selection-option-label text-weight-bold">
                {{ opt.label }}
              </span>
              <p v-if="opt.description" v-html="opt.description"></p>
            </div>
          </slot>
        </template>
      </QOptionGroup>
    </div>

    <div v-if="hasError && errorMessage" class="text-negative text-caption q-mt-xs" style="letter-spacing: inherit">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { QOptionGroup } from 'quasar';

export default {
  name: 'OptionGroupField',

  components: {
    QOptionGroup
  },

  props: {
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'secondary'
    },
    containerClass: {
      type: String,
      default: 'q-pa-xs col-12'
    }
  },

  data() {
    return {
      localValue: '',
      hasError: false,
      errorMessage: '',
      isDirty: false
    };
  },

  watch: {
    value(newValue) {
      this.localValue = newValue;

      if (this.isDirty) {
        this.validate();
      }
    }
  },

  created() {
    this.localValue = this.value;
  },

  methods: {
    getRules() {
      const rules = [];

      if (this.required) {
        rules.push((val) => {
          if (!val || val === '') {
            return 'Please select an option';
          }
          return true;
        });
      }

      return [...rules, ...this.rules];
    },

    validate() {
      this.isDirty = true;

      const rules = this.getRules();

      for (let i = 0; i < rules.length; i++) {
        const result = rules[i](this.localValue);

        if (result !== true) {
          this.hasError = true;
          this.errorMessage = result;
          return false;
        }
      }

      this.hasError = false;
      this.errorMessage = '';
      return true;
    },

    resetValidation() {
      this.isDirty = false;
      this.hasError = false;
      this.errorMessage = '';
    },

    handleInput(value) {
      this.localValue = value;
      this.$emit('input', value);

      if (this.isDirty) {
        this.validate();
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.option-group-field
  width: 100%

  &--error
    border: 2px solid var(--q-color-negative)
    border-radius: 8px
    box-sizing: border-box

  &--disabled
    opacity: 0.6

.option-group-field__group
  width: 100%
</style>
